import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'
import 'react-credit-cards/es/styles-compiled.css';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import ReactDOMServer from "react-dom/server";
import OpenModal from './OpenModal';
import color from '@material-ui/core/colors/amber';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',     
    transform             : 'translate(-50%, -50%)',
    padding               : '0',
    binvoice                : 'none',
    binvoiceRadius          : '0',
    boxShadow             : '0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.6)',
    overlfow              : 'hidden'
  }
};

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    margin: theme.spacing.unit / 2,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 24,
    }
  },
  typo: {
    padding: theme.spacing.unit * 3
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonLink: {
    color: 'inherit',
    textDecoration: 'none'
  },
  header: {
    paddingLeft: '24px',
    paddingRight: '24px', 
    fontSize: '26px',
    fontFamily: 'Averia Serif Libre, cursive',
    fontWeight: '100',
    color: 'red',
     backgroundColor: '#fa451c'
  },
  InvoiceInfo:{
    
  },
  invoiceinfo_container_web:{
    /*display: 'flex',*/
    width: '100%',
    /*content: 'center',*/
    marginTop: '10px'
  },
  invoice_Information:{
    fontSize:'14px'
  },
  invoiceInformation_head_top:{
   color:'#000',
   width:'100%',
   height:'30px'
  },
  invoicecode:{
    float: 'left',
    color:'#000',
    marginBottom: '.5%',
    paddingLeft:'10px'
  },
  invoiceDate:{
    float: 'right',
    color:'#000',
    marginBottom: '.5%',
    textAlign:'right',
    paddingRight:'10px'
  },
  invoiceInformation_head:{
  backgroundColor:'#000',
  color: '#fff',
  textAlign: 'center',
  height: '26px',
  lineHeight: '25px'
},
label:{
  width:'185px',
  display:'inline-block',
  paddingLeft:'10px'
},
billing_shipment_details:{
width: '100%',
display:'inline-block'
},
billing_details:{
  padding: '0 1%',
  paddingLeft: '0',
  width:'50%',
  float:'left'
},
shipment_details:{
  width:'50%',
  float:'right',
  padding: '0',
  paddingLeft: '0'
},
billing_head:{
  backgroundColor:'#000',
  color: '#fff',
  textAlign: 'center',
  height: '26px',
  lineHeight: '25px'
},
shipment_head:{
  backgroundColor:'#000',
  color: '#fff',
  textAlign: 'center',
  height: '26px',
  lineHeight: '25px'
},
invoiceItem_Information:{
  width:'100%'
},
item_Head:{
  display:'flex',
  backgroundColor:'#000',
  color: '#fff',
  padding:'0',
  margin:'0',
},
item_Body:{
  display:'flex',
  padding:'0',
  margin:'0',
},
item_Head_line:{
    flex: '1 1',
    padding: '1%',
    textAlign: 'center'
},
item_Body_line:{
  flex: '1 1',
  padding: '1%',
  textAlign: 'center'
}
});

class CreditMemoInfo extends Component {

  constructor(props) {
    super(props);   
    this.state = {
      modalIsOpen: false,
      creditMemoFullDetails:[],
      creditMemoItemDetails:[],
  }
   this.openModal = this.openModal.bind(this);      
   this.closeModal = this.closeModal.bind(this);
}

openModal = (modalMessage) =>{     
  this.setState(
      {
      modalIsOpen: true,
      modalMessage:modalMessage
  });        
}

componentWillMount() {
  let creditMemoNo = this.props.location.pathname.split('/')[2];
  this.getCreditMemoDetails(creditMemoNo);
}

async getCreditMemoDetails(creditMemoNo){
try{
  const response = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_CREDITMEMO_DETAIL_URL}?memonumber=${creditMemoNo}`,
  {
    method: 'GET',
    headers: {        
      Authorization: `${process.env.REACT_APP_API_TOKEN}`
    }})
  const data =  await response.json();
  if (data && data.length > 0) {
    //console.log(data.paramObjectsMap.invoiceDetails.invoiceLineDetails)
    this.setState({
      creditMemoFullDetails: data[0], 
      creditMemoItemDetails: data[0].creditMemoLineDetails
    })
  } else {

  }
  } catch(error) {
    
  }
 
}

closeModal = () => {
  this.setState({modalIsOpen: false});
}
downloadCreditMemoPDF(e,creditMemoNo){
  e.preventDefault();
  try{
    const response = fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_CREDITMEMO_DOWNLOAD_URL}?credit-memo-number=${creditMemoNo}`,
    {
      method: 'GET',
      headers: {        
        Authorization: `${process.env.REACT_APP_API_TOKEN}`
      }}).then((res) => { return res.blob(); })
      .then((data) => {
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(data);
        a.filename = creditMemoNo;
        a.target = "_blank";
        //a.download = invoiceNo;
        a.click();
      });
    } catch(error) {
      
    }
}
close_modal() {
  this.closeModal()
}

componentDidMount(){
}

render() {
    const { classes } = this.props;
    //console.log(classes);
    //const customer = JSON.parse(localStorage.getItem('customer'));
    //console.log(localStorage.getItem('customer'));
    //console.log(localStorage.getItem('token'));
    //console.log(localStorage.getItem('code'));
    let token = localStorage.getItem('token');
    let code =  localStorage.getItem('code');
    const creditMemoInfo = this.state.creditMemoFullDetails;
    const creditMemoLineInfo = this.state.creditMemoItemDetails;
    //console.log(invoiceLineInfo);
    return (
        <div id="invoice" className={classes.root}>
            <div className={classes.table}>
            <div className={classes.invoiceinfo_container_web}>
                    {this.state.creditMemoFullDetails !== null && this.state.creditMemoFullDetails !== '' && this.state.creditMemoFullDetails !== [] ?
                    <div>
                            {/* <div className="invoiceapproval-title">invoice Approval List</div> */}
                            <div className={classes.invoice_Information}>
                                <div className={classes.invoiceInformation_head_top}><label className={classes.invoicecode}></label><span className={classes.invoiceDate} style={{fontSize: '16px', color: '#fa451c', cursor: 'pointer',textDecoration:'underline',position:'relative',top:'-18px'}} onClick={(e)=>this.downloadCreditMemoPDF(e,creditMemoInfo.creditMemoNumber)}>Download Credit Memo PDF</span></div>
                                <div className={classes.invoiceInformation_head_top}><label className={classes.invoicecode}>Credit Memo Number: {creditMemoInfo.creditMemoNumber}</label><label className={classes.invoiceDate}>Credit Memo Date: {creditMemoInfo.postingDate}.</label></div>
                                <div className="clearfix"></div>
                                <div className={classes.invoiceInformation_head}>Credit Memo Information</div>
                                <div className={classes.invoiceInformation_details}>
                                    <p><label className={classes.label}>Customer Code</label><span>{creditMemoInfo.billToCustomerNo}</span></p>
                                    <p><label className={classes.label}>Posting Date</label><span>{creditMemoInfo.postingDate}</span></p>
                                    <p><label className={classes.label}>Posting Description</label><span>{creditMemoInfo.postingDescription}</span></p>
                                    <p><label className={classes.label}>Payment Terms</label><span>{creditMemoInfo.paymentTermsCode}</span></p>
                                    {typeof creditMemoInfo.orderNo !== "undefined" && creditMemoInfo.orderNo !== '' &&
                                    <p><label className={classes.label}>Sales Order Number</label><span>{creditMemoInfo.orderNo}</span></p> }
                                </div>
                                <div className={classes.invoiceInformation_head}>SRO Information</div>
                                <div className={classes.invoiceInformation_details}>
                                    <p><label className={classes.label}>SRO Number</label><span>{creditMemoInfo.returnOrderNo}</span></p>
                                    <p><label className={classes.label}>Tracking Number</label><span>{creditMemoInfo.sroTrackingNo}</span></p>
                                    {/*<p><label className={classes.label}>Date</label><span>{creditMemoInfo.sroModifiedTime}</span></p>*/}
                                    <p><label className={classes.label}>Type</label><span>{creditMemoInfo.repairSro === "1" ? "Repair" : "Return"}</span></p>
                                </div>
                                <div className={classes.billing_shipment_details}>
                                        <div className={classes.billing_details}>
                                            <p className={classes.billing_head}><span>Billing Address</span></p>
                                            <p><label className={classes.label}>Bill-to Name</label><span>{creditMemoInfo.billToName}</span></p>
                                            <p><label className={classes.label}>Bill-to Address </label><span>{creditMemoInfo.billToAddress}</span></p>
                                            <p><label className={classes.label}>Bill-to Address 2</label><span>{creditMemoInfo.billToAddress2}</span></p>
                                            <p><label className={classes.label}>Bill-to City</label><span>{creditMemoInfo.billToCity}</span></p>
                                            <p><label className={classes.label}>Bill-to State</label><span>{creditMemoInfo.billToCountry}</span></p>
                                            <p><label className={classes.label}>Bill-to Country</label><span>{creditMemoInfo.billToCtyRgnCode}</span></p>
                                            <p><label className={classes.label}>Bill-to Post Code</label><span>{creditMemoInfo.billToPostCode}</span></p>
                                            <p><label className={classes.label}>Bill-to Phone No</label><span>{creditMemoInfo.billToPhoneNo}</span></p>
                                        </div>
                                        <div className={classes.shipment_details}>
                                            <p className={classes.shipment_head}><span>Shipping Address</span></p>
                                            <p><label className={classes.label}>Ship-to Name</label><span>{creditMemoInfo.shipToName}</span></p>
                                            <p><label className={classes.label}>Ship-to Address </label><span>{creditMemoInfo.shipToAddress}</span></p>
                                            <p><label className={classes.label}>Ship-to Address 2</label><span>{creditMemoInfo.shipToAddress2}</span></p>
                                            <p><label className={classes.label}>Ship-to City</label><span>{creditMemoInfo.shipToCity}</span></p>
                                            <p><label className={classes.label}>Ship-to State</label><span>{creditMemoInfo.sellToCountry}</span></p>
                                            <p><label className={classes.label}>Ship-to Country</label><span>{creditMemoInfo.sellToCtyRgnCode}</span></p>
                                            <p><label className={classes.label}>Ship-to Post Code</label><span>{creditMemoInfo.sellToPostCode}</span></p>
                                            <p><label className={classes.label}>Ship-to Phone No</label><span>{creditMemoInfo.sellToPhoneNo}</span></p>
                                        </div>
                                </div>
                                <div className={classes.invoiceItem_Information}>
                                    <ul className={classes.item_Head} style={{listStyle:'none'}}>
                                        <li className={classes.item_Head_line}>Item Number</li>
                                        <li className={classes.item_Head_line}>Division Code</li>
                                        <li className={classes.item_Head_line}>Description</li>
                                        <li className={classes.item_Head_line}>Quantity</li>
                                        <li className={classes.item_Head_line}>Unit Price</li>
                                        {<li className={classes.item_Head_line}>Line Discount Amount</li>}
                                        <li className={classes.item_Head_line}>Amount</li>
                                    </ul>                                    
                                    {creditMemoLineInfo.map((item) =>
                                    (item.type == '2' && item.itemNumber !='') &&
                                      <ul className={classes.item_Body} style={{listStyle:'none'}}>
                                       <li className={classes.item_Body_line}>{item.itemNumber}</li> 
                                       <li className={classes.item_Body_line}>{item.shortcutDimensionCode1+' '+item.shortcutDimensionCode2}</li> 
                                       <li className={classes.item_Body_line}>{item.description+' '+item.description2}</li> 
                                       <li className={classes.item_Body_line}>{item.quantity > 0 ? parseInt(item.quantity) : parseInt(0)}</li> 
                                       <li className={classes.item_Body_line}><NumberFormat value={item.unitPrice} fixedDecimalScale={true} style={{ fontSize: 12, marginTop: '0%' }} decimalScale={2} displayType={'text'}></NumberFormat></li> 
                                       <li className={classes.item_Body_line}><NumberFormat value={item.lineDiscountAmount!=="0E-20" ? item.lineDiscountAmount : parseInt(0)} fixedDecimalScale={true} style={{ fontSize: 12, marginTop: '0%' }} decimalScale={2} displayType={'text'}></NumberFormat></li>
                                       <li className={classes.item_Body_line}><NumberFormat value={item.amount} fixedDecimalScale={true} style={{ fontSize: 12, marginTop: '0%' }} decimalScale={2} displayType={'text'}></NumberFormat></li> 
                                       </ul>  
                                    )}
                                    
                                </div>
                        </div> </div>
                        : ''}
                    </div>
              
            </div>           
        </div>
        
    );
  }
}

CreditMemoInfo.propTypes = {
  classes: PropTypes.object.isRequired
};

export default (withStyles(styles)(CreditMemoInfo));


// WEBPACK FOOTER //
// ./src/CreditMemoInfo.js